/*
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2021-06-01 14:10:29
 * @LastEditTime: 2024-02-23 11:02:20
 * @Description: 
 * @
 * @Copyright (c) 2022 by yubaolee | ahfu~ , All Rights Reserved. 
*/
import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/custom-theme/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VueContextMenu from 'vue-contextmenu'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/permission' // permission control

import { initErrorMonitor, reportJsError } from '@/lib/monitor-log'
// 注册全局JS错误、资源错误、未处理Promise异常监听上报
initErrorMonitor()

import '@/assets/public/css/comIconfont/iconfont.css'
import '@/assets/public/css/comIconfont/iconfont.js'

//工作流使用的图标
import '@/assets/public/css/workflowicon/iconfont.css'
import '@/assets/public/css/workflowicon/iconfont.js'


import '../public/ueditor/ueditor.config.js'
import '../public/ueditor/ueditor.all.js'
import '../public/ueditor/lang/zh-cn/zh-cn.js'
import '../public/ueditor/formdesign/leipi.formdesign.v4.js'

import vform from '@/lib/vform/VFormDesigner.umd.min.js'
import '@/lib/vform/VFormDesigner.css'

//HiPrint默认会自动连接本机安装的客户端，如若不需要直接打印功能，或者不自动连接，需要关闭自动连接
import { disAutoConnect } from 'vue-plugin-hiprint'
disAutoConnect();

import '@wangeditor/editor/dist/css/style.css'// wangeditorV5版本样式
import WangEditor from '@/components/wangEditor/index';
import EDialog from '@/components/e-dialog/e-dialog';
import ETable from '@/components/e-table/e-table';
import STable from '@/components/e-table/s-table';
import EDrawer from '@/components/e-dialog/e-drawer';
import comUploadFile from '@/components/com-upload-file/com-upload-file';
import BaseLayout from '@/components/baseLayout'
Vue.component('WangEditor', WangEditor)
Vue.component('e-dialog', EDialog)
Vue.component('e-drawer', EDrawer)
Vue.component('e-table', ETable)
Vue.component('s-table', STable)
Vue.component('com-upload-file', comUploadFile)
Vue.component('BaseLayout', BaseLayout)

Vue.use(ElementUI, { locale })
Vue.use(VueContextMenu)
Vue.use(vform)

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.config.errorHandler = function (err, vm, info) {
  // 记录错误日志、通知系统、或显示用户友好的错误提示
  console.error('捕获到未处理的错误:', err, info);
  // 组件内错误上报（生产环境Vue不会re-throw，必须通过errorHandler才能捕获）
  reportJsError(err, (vm && vm.$options && vm.$options.name) ? `${vm.$options.name} - ${info}` : info);
};
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
